<template>
  <div :class="['code-viewer']"><pre><code><slot /></code></pre></div>
</template>
<script>
export default {
  name: 'CodeBlock'
}
</script>
<style>
.code-viewer pre
{
  font-size: .9em;
  font-family: Consolas, Inconsolata, Menlo, Monaco, Courier, "Courier New", "Andale Mono", monospace;
}
</style>


// WEBPACK FOOTER //
// code-block.vue?ecc78250